export class ModelHelper {
    public static getClass(entitySet: string): any {
        
    }
}
